// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type EventDetailQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  eventIdJson: PrivateSchemaTypes.Scalars['JSON'];
}>;


export type EventDetailQuery = (
  { __typename?: 'Query' }
  & { event?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'EventModelAsStudent' }
    & Pick<PrivateSchemaTypes.EventModelAsStudent, 'id' | 'author_id' | 'title' | 'description' | 'start_time' | 'end_time' | 'location' | 'created_at' | 'updated_at' | 'published_date' | 'participants_limit' | 'organisation_id' | 'update_email_sent_at' | 'is_open' | 'allow_comments' | 'timezone' | 'google_meet_id' | 'ms_teams_enabled' | 'ms_teams_url'>
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsStudent' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsStudent, 'id' | 'title'>
      & { events: Array<(
        { __typename?: 'EventModel' }
        & ReccurringEventInDetailFragment
      )> }
    )>, facilitator?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id'>
    )>, author: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
    ), attendedInvitees: Array<(
      { __typename?: 'UserEventModel' }
      & Pick<PrivateSchemaTypes.UserEventModel, 'attending' | 'certification_id'>
      & { user: (
        { __typename?: 'UserModel' }
        & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity' | 'display_name' | 'position' | 'image_url'>
      ) }
    )>, currentUserInvitee?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserEventModel' }
      & Pick<PrivateSchemaTypes.UserEventModel, 'attending' | 'last_edit_by'>
    )>, invitedGroups: Array<(
      { __typename?: 'GroupModelGQLBase' }
      & Pick<PrivateSchemaTypes.GroupModelGqlBase, 'name'>
    )> }
  )>, me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id' | 'timezone'>
  ) }
);

export type ReccurringEventInDetailFragment = (
  { __typename?: 'EventModel' }
  & Pick<PrivateSchemaTypes.EventModel, 'id' | 'title' | 'start_time'>
);

export const ReccurringEventInDetailFragmentDoc = gql`
    fragment reccurringEventInDetail on EventModel {
  id
  title
  start_time
}
    `;
export const EventDetailDocument = gql`
    query eventDetail($eventId: PositiveInt!, $eventIdJson: JSON!) {
  event(id: $eventId) {
    id
    author_id
    title
    description
    start_time
    end_time
    location
    created_at
    updated_at
    published_date
    participants_limit
    organisation_id
    update_email_sent_at
    is_open
    allow_comments
    timezone
    google_meet_id
    ms_teams_enabled
    ms_teams_url
    recurringEvent {
      id
      title
      events(
        filters: [{name: afterEventId, value: $eventIdJson}]
        order: {name: "start_time", sort: "ASC"}
      ) {
        ...reccurringEventInDetail
      }
    }
    facilitator {
      id
    }
    author {
      id
      display_name
    }
    attendedInvitees {
      attending
      certification_id
      user {
        id
        userIdentity
        display_name
        position
        image_url
      }
    }
    currentUserInvitee {
      attending
      last_edit_by
    }
    invitedGroups {
      name
    }
  }
  me {
    id
    timezone
  }
}
    ${ReccurringEventInDetailFragmentDoc}`;

/**
 * __useEventDetailQuery__
 *
 * To run a query within a React component, call `useEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDetailQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventIdJson: // value for 'eventIdJson'
 *   },
 * });
 */
export function useEventDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EventDetailQuery, EventDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EventDetailQuery, EventDetailQueryVariables>(EventDetailDocument, options);
      }
export function useEventDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventDetailQuery, EventDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EventDetailQuery, EventDetailQueryVariables>(EventDetailDocument, options);
        }
export type EventDetailQueryHookResult = ReturnType<typeof useEventDetailQuery>;
export type EventDetailLazyQueryHookResult = ReturnType<typeof useEventDetailLazyQuery>;
export type EventDetailQueryResult = Apollo.QueryResult<EventDetailQuery, EventDetailQueryVariables>;